import { createOptions } from 'options';

export type OOHCategory = string;
export type OOHCategoryFormat = string;
export type OOHCategoryFormatMeta = {
  description: string;
  common_terminology: string | null;
  standard_dimensions: string | null;
  specifications: string | null;
};

export type CategoryFormatOption = {
  value: OOHCategoryFormat;
  label: string;
} & OOHCategoryFormatMeta;

export const oohDisplayTypes = ['STATIC', 'ILLUMINATED', 'DIGITAL', 'HYBRID'] as const;
export type OOHDisplayType = (typeof oohDisplayTypes)[number];

export const displayTypeOptions = createOptions(oohDisplayTypes);

export type OOHFormat = {
  display_type: OOHDisplayType;
  market_dma: string;
  dimensions: string;
  area: string;
  url: string;
  lat: string | null;
  lon: string | null;
  audience_data: string;
  quantity: number;
  // digital fields
  loop_length_sec: number | null;
  spot_length_sec: number | null;
  spots_per_loop: number | null;
};

export type OOHConfig = {
  category_format: OOHCategoryFormat;
  code_or_number: string;
  format: OOHFormat;
};
